import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/company';

export class CompanyService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async createDesignDemoLicense(params: types.CreateDesignDemoLicenseParameters): Promise<void> {
    await this.axios.post<types.CreateDesignDemoLicenseParameters>(
      `/companies/${params.path.companyId}/licenses`,
    );
  }

  getDesignToolSeats(
    params: types.GetDesignToolSeatsParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    throw new Error('Method not implemented.');
  }
  createDesignToolSeat(
    params: types.CreateDesignToolSeatParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    throw new Error('Method not implemented.');
  }
  deleteDesignToolSeat(params: types.DeleteDesignToolSeatParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }
  patchDesignToolSeat(
    params: types.PatchDesignToolSeatParameters,
  ): Promise<types.GetDesignToolSeatsResponse> {
    throw new Error('Method not implemented.');
  }
  createCompany(params: types.CreateCompanyParameters): Promise<types.CreateCompanyResponse> {
    throw new Error('Method not implemented.');
  }
  async fetchProjectCompany(
    params: types.FetchProjectCompanyParameters,
  ): Promise<types.ProjectCompanyResponse> {
    const { data } = await this.axios.get<types.ProjectCompanyResponse>(
      `/companies/fetchProjectCompany?id=${params.query.id}`,
    );
    return data;
  }
  async fetchAllCompanies(
    params: types.FetchAllCompaniesParameters,
  ): Promise<types.CompaniesResponse> {
    const { data } = await this.axios.get<types.CompaniesResponse>('companies/fetchCompanies');
    return data;
  }
  async fetchUserCompanies(
    params: types.FetchUserCompaniesParameters,
  ): Promise<types.UserCompaniesResponse> {
    const { data } = await this.axios.get<types.UserCompaniesResponse>(
      `/companies/fetchUserCompanies?id=${params.query.id}`,
    );
    return data;
  }
  async getCompanyAdminRequest(
    params: types.GetCompanyAdminRequestParameters,
  ): Promise<types.CompanyAdminRequestResponse> {
    const { data } = await this.axios.get<types.CompanyAdminRequestResponse>(
      `companies/getcompanyadminrequest?requestId=${params.query.requestId}`,
    );
    return data;
  }
  async inviteCompanyAdmin(
    params: types.InviteCompanyAdminParameters,
  ): Promise<types.InviteCompanyAdminRequestResponse> {
    const { data } = await this.axios.post(`companies/invitecompanyadmin`, params.body);
    return data;
  }
  async register(params: types.RegisterParameters): Promise<types.SuccessResponse> {
    const { data } = await this.axios.post(`companies/register`, params.body);
    return data;
  }
  async verifyCompanyAdmin(
    params: types.VerifyCompanyAdminParameters,
  ): Promise<types.SuccessResponse> {
    const { data } = await this.axios.put<types.SuccessResponse>(
      `companies/user/verification/${params.path.token}`,
      params.body,
    );
    return data;
  }
  async headRegistrationToken(
    params: types.HeadRegistrationTokenParameters,
  ): Promise<types.SuccessResponse> {
    const { data } = await this.axios.head<types.SuccessResponse>(
      `companies/user/verification/${params.path.token}`,
    );
    return data;
  }
}
